export default __webpack_public_path__ + "static/media/adrenalin.1bd4434e.png";